import { post } from '@webapp-next/lib/request/webapp/apiv2';
import { AxiosError } from 'axios';
import {
  APIErrorResponse,
  APIResponseSuccess,
} from '@/lib/types/request/types';
import { SaveScheduleTemplate } from '@/modules/schedule/types/save-and-load';

const url = '/api/management/v2/schedule/template';

export default async function saveTemplate(
  data: SaveScheduleTemplate
): Promise<APIResponseSuccess | APIErrorResponse> {
  try {
    const { success }: { success: boolean } = await post(url, data);
    return { success };
  } catch (error) {
    const axiosError: AxiosError = error as AxiosError;
    if (axiosError.response) {
      // TODO: wrong type
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      throw new Error(axiosError.response.data.error);
    } else {
      throw new Error(axiosError.message);
    }
  }
}
